import ImageIcon from "@redotech/redo-icons/image-plus.svg";
import { ImageElement } from "@redotech/redo-model/content-builder/element-schema";
import { memo } from "react";
import { Flex } from "../../flex";
import { getBaseElementStyles } from "./base-element-styles";
import * as ImageCSS from "./form-image.module.css";

export const FormImage = memo(function FormImage({
  element,
}: {
  element: ImageElement;
}) {
  const hasImage = element.url !== "";
  const baseStyles = getBaseElementStyles(element);

  return (
    <Flex height="full" style={baseStyles} w="full">
      {hasImage ? (
        <img
          src={element.url}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            ...(element.cornerRadius !== undefined && {
              borderRadius: `${element.cornerRadius}px`,
            }),
          }}
        />
      ) : (
        <div className={ImageCSS.placeholder}>
          <ImageIcon />
          Add image
        </div>
      )}
    </Flex>
  );
});
